import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Switch, Route, Redirect } from 'react-router-dom'
import {
  withStyles,
} from '@material-ui/core'

import User from './User'
import Order from './Order'
import Header from './Header'
import Market from './Market'
import AddOrder from './AddOrder'
import AddMarket from './AddMarket'
import Dashboard from './Dashboard'
import ListUsers from './ListUsers'
import ListRefund from './ListRefund'
import ListOrders from './ListOrders'
import ListMarkets from './ListMarkets'
import Drawer from '../components/Drawer'
import { navigate } from '../actions/app'
import { ROUTES, IS_ADMIN, IS_SHOP } from '../constant'
import PageAdminTasks from './PageAdminTasks'


const styles = theme => ({
  root: {
    overflowX: 'hidden',
  },
  container: {
    position: 'relative',
    width: '100vw',
    display: 'flex',
    minHeight: 'calc(100vh - 64px)',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.25)',
    background: '-webkit-linear-gradient(45deg, #f5f5f5 30px, #f5f5f5 30px), -webkit-linear-gradient(135deg, transparent 30px, #f5f5f5 30px), -webkit-linear-gradient(225deg, #f5f5f5 30px, #f5f5f5 30px), -webkit-linear-gradient(315deg, transparent 30px, #f5f5f5 30px)',
  },
  content: {
    flex: 1,
    maxWidth: 1400,
    margin: '0 auto',
    padding: theme.spacing(1),
  },
})


class PageAdmin extends Component {
  /* LIFECYCLE */

  state = {
    drawerOpened: false,
  }


  /* METHODS */

  handleToggleDrawer = () => this.setState({ drawerOpened: !this.state.drawerOpened })


  /* RENDER */

  /**
   * @render
   * @returns {JSX}
   */
  render() {
    const {
      uid,
      classes,
    } = this.props
    const { drawerOpened } = this.state

    return (
      <div className={classes.root}>
        <Header
          drawerOpened={drawerOpened}
          onToggleDrawer={this.handleToggleDrawer}
        />

        <div className={classes.container}>
          {IS_ADMIN && <Drawer opened={drawerOpened} pathname={this.props.location.pathname} onNavigate={this.props.navigate} />}
          <main className={classes.content}>
            {uid && (
              <>
                {IS_ADMIN && (
                  <Switch>
                    <Route exact path="/" component={Dashboard} />

                    <Route exact path={ROUTES.USER} component={ListUsers} />
                    <Route exact path={`${ROUTES.USER}/:uid`} component={User} />

                    <Route exact path={ROUTES.REFUND} component={ListRefund} />

                    <Route exact path={ROUTES.ORDER} component={ListOrders} />
                    <Route exact path={`${ROUTES.ORDER}/add`} component={AddOrder} />
                    <Route exact path={`${ROUTES.ORDER}/:uid`} component={Order} />

                    <Route exact path={ROUTES.MARKET} component={ListMarkets} />
                    <Route exact path={`${ROUTES.MARKET}/add`} component={AddMarket} />
                    <Route exact path={`${ROUTES.MARKET}/:uid`} component={Market} />

                    <Route exact path="/admin" component={PageAdminTasks} />

                    <Redirect to="/" />
                  </Switch>
                )}

                {IS_SHOP && (
                  <Switch>
                    <Route exact path="/" component={Market} />
                    <Route exact path="/edit" component={AddMarket} />

                    <Redirect to="/" />
                  </Switch>
                )}
              </>
            )}
          </main>
        </div>
      </div>
    )
  }
}


PageAdmin.propTypes = {
  uid: PropTypes.string,
  navigate: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
}


const mapStateToProps = state => ({
  uid: state.app.uid,
})

export default connect(mapStateToProps, {
  navigate,
})(withStyles(styles)(PageAdmin))
